import { CommonModule, NgFor, NgIf } from '@angular/common'
import { Component, inject } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'
import { selectSalaryComponents } from '../../../../store/salary-components/salary-components.selectors'
import { SalaryComponent } from '../../../../store/salary-components/salary-components.state'
import {
  addSalaryComponent,
  deleteSalaryComponent,
  editSalaryComponent,
  loadSalaryComponents
} from '../../../../store/salary-components/salary-components.actions'
import { HasPermissionDirective } from '../../../../directives/has-permission.directive'
import { STANDARD_EARNINGS } from '../../../../store/state.constants'

@Component({
  selector: 'app-standard-earnings',
  imports: [NgFor, NgIf, FormsModule, ReactiveFormsModule, CommonModule, HasPermissionDirective],
  templateUrl: './standard-earnings.component.html',
  styleUrl: './standard-earnings.component.scss'
})
export class StandardEarningsComponent {
  private modalService = inject(NgbModal)
  private fb = inject(FormBuilder)
  private store = inject(Store)

  //States
  form!: FormGroup
  currentStep = 1
  operation = 'Add'
  itemId = ''

  ////Add modal for the items
  //@ViewChild('addEarningModal', { static: true })
  //earningModalTemplate: TemplateRef<unknown>

  //@ViewChild('deleteModal', { static: true })
  //deleteModalTemplate: TemplateRef<unknown>

  standardEarnings$ = this.store.select(selectSalaryComponents(STANDARD_EARNINGS))

  constructor() {
    this.initializeForm()
    this.store.dispatch(loadSalaryComponents({ componentType: STANDARD_EARNINGS, belongsTo: null }))
  }

  initializeForm() {
    this.form = this.fb.group({
      belongsTo: [''],
      name: ['', Validators.required],
      description: [''],
      componentType: [STANDARD_EARNINGS],
      info: this.fb.group({
        payType: ['fixedPay'],
        calculationType: ['flatAmount'],
        paymentFrequency: ['monthly'],
        taxDeductionPreference: ['subsequentPayrolls'],
        taxable: [true],
        isInCTC: [true],
        isInFBP: [true],
        proRataBasis: [true],
        EPFContribution: [true],
        ESIContribution: [true]
      })
    })
  }

  sendDataToParent() {
    switch (this.operation) {
      case 'Add':
        this.store.dispatch(addSalaryComponent({ salaryComponent: this.form.value }))
        break
      case 'Edit':
        this.store.dispatch(
          editSalaryComponent({ id: this.itemId, salaryComponent: this.form.value })
        )
        break
      case 'Delete':
        this.store.dispatch(
          deleteSalaryComponent({ id: this.itemId, componentType: STANDARD_EARNINGS })
        )
        break
      default:
        break
    }
    this.onClose()
  }

  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    // console.log('control name', control)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
    }
    return null // No error
  }

  openModel(modal: unknown) {
    this.operation = 'Add'
    this.itemId = ''
    this.modalService.open(modal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }

  openEditModal(modal: unknown, itemData: SalaryComponent) {
    this.operation = 'Edit'
    this.itemId = itemData.id
    this.form.get('belongsTo')?.setValue(itemData.belongsTo)
    this.form.get('name')?.setValue(itemData.name)
    this.form.get('description')?.setValue(itemData.description)
    this.form.get('type')?.setValue(itemData.componentType)
    this.form.get('info')?.setValue(itemData.info)

    this.modalService.open(modal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }

  openDeleteModal(modal: unknown, itemData: SalaryComponent) {
    this.operation = 'Delete'
    this.itemId = itemData.id
    this.modalService.open(modal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }

  // Function to check if the current step is valid
  isStepValid(): boolean {
    switch (this.currentStep) {
      case 1:
        return !!this.form.get('name')?.valid
      case 2:
        return !!this.form.get('info')?.valid
      default:
        return false
    }
  }

  goToNextStep(): void {
    if (this.isStepValid()) {
      this.currentStep++
    } else {
      alert('Please complete the form before proceeding!')
    }
  }

  stepChange(newStep: number): void {
    if (this.isStepValid()) {
      this.currentStep = newStep
    }
  }

  onClose() {
    this.currentStep = 1
    this.modalService.dismissAll()
    this.form.reset()
    this.initializeForm()
  }
}
